import { ArrowDownLeft,ArrowUpRight } from "lucide-react";
export const StatCard = ({ title, value, unit, growth,direction }: any) => {
  return (
    <div className="bg-white rounded-2xl shadow p-4 flex flex-col w-full lg :w-56">
      {/* Title */}
      <p className="text-gray-500 text-sm">{title}</p>

      {/* Value */}
      <div className="flex items-end gap-1">
        <h3 className="text-2xl font-semibold text-gray-900">{value}</h3>
        {unit && <span className="text-gray-500 text-sm">{unit}</span>}
      
      </div>

      {/* Growth */}
      {growth && direction=='Positive'?(
        <div className="flex items-center gap-1 text-green-600 text-sm mt-1">
          <ArrowUpRight size={14} />         
          <span>+ {growth} % </span>
        </div>):(
         <div className="flex items-center gap-1 text-red-600 text-sm mt-1">          
          <ArrowDownLeft size={14} />
          <span>- {Math.abs(growth)} % </span>
        </div>)
      }
    </div>
  );
};